export default __webpack_public_path__ + "static/media/2-微信二维码.bdb6f70d.jpg";